module.exports = __webpack_public_path__ + "static/media/login-bg-2.2a85b3c7.png";